import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axiosInstance from 'axiosConfig';
import { Toast } from 'components';
import { TOAST_TYPES_ENUM } from 'enums';
import { queryClient } from 'App';

type DeleteItemData = {
  uuid: string;
};

const useDeleteItemLeftAtClient = (
  options?: UseMutationOptions<any, Error, DeleteItemData>
) => {
  return useMutation({
    ...options,
    mutationKey: ['deleteItem'],
    mutationFn: async (data: DeleteItemData) => {
      return axiosInstance
        .delete(`/installation/items/delete/${data.uuid}`)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: 'Usuwanie rzeczy...',
        type: TOAST_TYPES_ENUM.LOADING,
        id: 'delete-item',
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: 'Rzecz została usunięta pomyślnie.',
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: 'delete-item',
      });
      queryClient.invalidateQueries({ queryKey: ['orderDetails'] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: 'Błąd podczas usuwania rzeczy.',
        type: TOAST_TYPES_ENUM.ERROR,
        id: 'delete-item',
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useDeleteItemLeftAtClient;
